import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { limitsAndPayoutsStore } from '../../../store/limitsAndPayoutsStore';
import LimitsAndPayoutItem from './limitsAndPayoutItem';
import { BET_TYPES_LIMITS_KEYS } from '../../../enums/limitsAndPayoutConstants';

const LimitAndPayouts = observer(({ isFromRules }) => {
  const { currencyCode } = userInfoStore;
  const { limitsPayouts } = limitsAndPayoutsStore;
  const {
    limits: { additionalLimits },
  } = gameConfigStore;
  const t = useTranslation();

  const limitsPayoutKeys = useMemo(() => {
    const limitsKeys = additionalLimits ? Object.keys(additionalLimits) : [];
    const payoutKeys = Object.keys(limitsPayouts);
    if (limitsKeys.length && payoutKeys.length) {
      return payoutKeys;
    }
    return [];
  }, [limitsPayouts, additionalLimits]);

  return (
    <div className={`limit-payouts-holder ${isFromRules ? 'from-rules' : ''}`}>
      <div className='tb-limit-payout-body'>
        {limitsPayoutKeys.map((key) => {
          return (
            <LimitsAndPayoutItem
              t={t}
              key={key}
              isFromRules={isFromRules}
              currencyCode={currencyCode}
              limits={additionalLimits[key]}
              limitsAndPayoutItem={limitsPayouts[key]}
              limitsAndPayoutsItemHeaderName={t(BET_TYPES_LIMITS_KEYS[key])}
            />
          );
        })}
      </div>
    </div>
  );
});

export default LimitAndPayouts;
